export default __webpack_public_path__ + "static/media/world.02424651.svg";